'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'user-shakespeare';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e2c2';
var svgPathData = ['M8 512c4.4 0 8-3.6 8-8l0-8c0-59.2 32.2-110.9 80-138.6L96 368c0 26.5 21.5 48 48 48l72 0 0 88c0 4.4 3.6 8 8 8L8 512zM72.1 215.1c.3-3.7 1.4-7.3 3.3-10.4l28.8-47.9c1.3 32.9 15.8 62.4 38.3 83.3l-47.1 0c-7.4 0-14-3.4-18.3-8.9-2.9-4.7-4.6-10.2-5-16zM224 512c4.4 0 8-3.6 8-8l0-88 72 0c26.5 0 48-21.5 48-48l0-10.6c47.8 27.7 80 79.4 80 138.6l0 8c0 4.4 3.6 8 8 8l-216 0zm81.6-272c23.1-21.4 37.7-51.8 38.4-85.6 4.9 7.4 13.8 20.7 26.3 39.4 3.4 5.2 5.4 11.2 5.8 17.4 0 .6 0 1.2 0 1.9-1 15.1-13.5 27-28.8 27l-41.6 0z', 'M328 152c0 54.7-42.3 99.6-96 103.7l0-31.7c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 31.7c-53.7-4.1-96-49-96-103.7l0-32c0-57.4 46.6-104 104-104S328 62.6 328 120l0 32zM224 0C157.7 0 104 53.7 104 120l0 5.8-42.4 70.7c-3.7 6.1-5.6 13.1-5.6 20.2 0 21.7 17.6 39.3 39.3 39.3l68.8 0c17.6 10.2 38.1 16 59.9 16s42.3-5.8 59.9-16l63.2 0c24.8 0 44.8-20.1 44.8-44.8 0-8.9-2.6-17.5-7.5-24.9l-40.5-60.7 0-5.6C344 53.7 290.3 0 224 0zM104.1 156.7c1.3 32.9 15.8 62.4 38.3 83.3l-47.1 0c-12.9 0-23.3-10.4-23.3-23.3 0-4.2 1.1-8.4 3.3-12l28.8-47.9zM347.2 240l-41.6 0c23.1-21.4 37.7-51.8 38.4-85.6l27.2 40.8c3.2 4.7 4.8 10.3 4.8 16 0 15.9-12.9 28.8-28.8 28.8zM220.4 152.8l-40 20c-4 2-5.6 6.8-3.6 10.7s6.8 5.6 10.7 3.6l36.4-18.2 36.4 18.2c4 2 8.8 .4 10.7-3.6s.4-8.8-3.6-10.7l-40-20c-2.3-1.1-4.9-1.1-7.2 0zM16 496c0-59.2 32.2-110.9 80-138.6L96 368c0 26.5 21.5 48 48 48l72 0 0 88c0 4.4 3.6 8 8 8s8-3.6 8-8l0-88 72 0c26.5 0 48-21.5 48-48l0-10.6c47.8 27.7 80 79.4 80 138.6l0 8c0 4.4 3.6 8 8 8s8-3.6 8-8l0-8c0-69.2-39.9-129.1-98-157.8-5.9-19.8-24.3-34.2-46-34.2l-160 0c-21.7 0-40 14.4-46 34.2-58.1 28.8-98 88.6-98 157.8l0 8c0 4.4 3.6 8 8 8s8-3.6 8-8l0-8zm96-144c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 16c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserShakespeare = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;